import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const MaskLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block will-change-transform"
      initial={{ y: "115%" }}
      animate={{ y: 0 }}
      transition={{ duration: 1, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const Rise = ({ children, delay = 0, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 44 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ num, label, dark = false }) => (
  <div
    className={`flex items-center gap-3 font-mono2 text-[11px] font-bold uppercase tracking-[0.35em] ${
      dark ? "text-paper/70" : "text-ink/60"
    }`}
  >
    <span className="text-rust">{num}</span>
    <span className={`h-px w-10 ${dark ? "bg-paper/40" : "bg-ink/40"}`} />
    <span>{label}</span>
  </div>
);

export const Star = ({ className = "fill-rust", size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" className={className} aria-hidden="true">
    <path d="M12 0l2.6 9.4L24 12l-9.4 2.6L12 24l-2.6-9.4L0 12l9.4-2.6z" />
  </svg>
);

export const Flags = ({ text, size = "sm", blueFrom = Infinity }) => {
  const big = size === "lg";
  return (
    <span className="inline-flex flex-col" role="img" aria-label={text}>
      <span className={`w-full bg-ink ${big ? "h-[3px]" : "h-[2px]"}`} />
      <span className="inline-flex items-start">
        {text.split("").map((c, i) =>
          c === " " ? (
            <span key={i} className={big ? "w-3" : "w-1.5"} />
          ) : (
            <span
              key={i}
              aria-hidden="true"
              className={`inline-flex justify-center ${
                i >= blueFrom ? "bg-rust" : "bg-polered"
              } font-display uppercase leading-none text-paper ${
                big
                  ? "px-[9px] pb-[10px] pt-[5px] text-[22px] sm:px-[13px] sm:pb-[14px] sm:pt-[8px] sm:text-[32px]"
                  : "px-[6px] pb-[7px] pt-[3px] text-[13px]"
              }`}
              style={{
                clipPath: "polygon(0 0, 100% 0, 80% 100%, 20% 100%)",
                transform: `rotate(${i % 2 === 0 ? -2.5 : 2}deg)`,
                marginLeft: "-1px",
              }}
            >
              {c}
            </span>
          )
        )}
      </span>
    </span>
  );
};
